import { render, staticRenderFns } from "./AppointmentAcceptModal.vue?vue&type=template&id=67da4753&scoped=true&"
import script from "./AppointmentAcceptModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentAcceptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67da4753",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/dev/LogimedAPP/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VDialog,VDivider,VForm,VTextarea})
